import { Button, Popconfirm } from 'antd';
import { ReactNode, VFC } from 'react';
import { useIntl } from 'react-intl';
import { GroupMetersTable as messages } from '../messages';

interface DeleteActionButtonProps {
  id?: number;
  confirmTitle: string;
  isLoading?: boolean;
  icon?: ReactNode;
  label?: string;
  onDelete: (id: number) => void;
}

export const DeleteActionButton: VFC<DeleteActionButtonProps> = ({
  id,
  confirmTitle,
  isLoading,
  icon,
  label,
  onDelete,
}) => {
  const intl = useIntl();

  if (!id) return null;

  return (
    <Popconfirm
      cancelButtonProps={{
        style: {
          paddingTop: 4,
          paddingBottom: 4,
          height: 'auto',
          lineHeight: '1.5',
        },
      }}
      cancelText={intl.formatMessage(messages.cancel)}
      okButtonProps={{
        danger: true,
        style: {
          marginLeft: 8,
          paddingTop: 4,
          paddingBottom: 4,
          height: 'auto',
          lineHeight: '1.5',
        },
      }}
      okText={intl.formatMessage(messages.delete)}
      placement="left"
      title={confirmTitle}
      onConfirm={() => onDelete(id)}
    >
      <Button danger icon={icon} loading={isLoading} type="text">
        {label}
      </Button>
    </Popconfirm>
  );
};
